import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { g as getRem } from './styled-utils-3f8463ca.js';

function _templateObject5() {
  var data = _taggedTemplateLiteral(["margin-top: ", ";"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["margin-left: ", ";"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    align-items: flex-start;\n    flex-direction: row;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n  ", ";\n\n  & > * {\n    margin: 0;\n    flex: ", ";\n  }\n\n  & > * + * {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledStack = styled.div(_templateObject(), function (_ref) {
  var horizontal = _ref.horizontal;
  return horizontal ? css(_templateObject2()) : css(_templateObject3());
}, function (_ref2) {
  var horizontal = _ref2.horizontal;
  return horizontal ? '0 0 auto' : '1 1 auto';
}, function (_ref3) {
  var horizontal = _ref3.horizontal,
      spacing = _ref3.spacing,
      theme = _ref3.theme;
  return horizontal ? css(_templateObject4(), getRem(theme.space[spacing])) : css(_templateObject5(), getRem(theme.space[spacing]));
});

var Stack = function Stack(_ref) {
  var horizontal = _ref.horizontal,
      spacing = _ref.spacing,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(StyledStack, {
    className: className,
    spacing: spacing,
    horizontal: horizontal
  }, children);
};

Stack.defaultProps = {
  children: null,
  className: null,
  horizontal: false,
  spacing: 'sm'
};
Stack.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stack",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "horizontal": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "spacing": {
      "defaultValue": {
        "value": "'sm'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'xxxs'",
          "computed": false
        }, {
          "value": "'xxs'",
          "computed": false
        }, {
          "value": "'xs'",
          "computed": false
        }, {
          "value": "'sm'",
          "computed": false
        }, {
          "value": "'md'",
          "computed": false
        }, {
          "value": "'lg'",
          "computed": false
        }, {
          "value": "'xl'",
          "computed": false
        }, {
          "value": "'xxl'",
          "computed": false
        }, {
          "value": "'xxxl'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    }
  }
};
export default Stack;
export { Stack };